export default "__VITE_ASSET__17e93750__"